import { styled } from "@mui/material/styles";

export const ProductContentSections = styled("div")(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(4),
    flexDirection: "column",
}));
